export const GET_START_FORM = 'GET_START_FORM';
export const GET_START_FORM_SUCCESS = 'GET_START_FORM_SUCCESS';
export const GET_START_FORM_FAILURE = 'GET_START_FORM_FAILURE';
